import { msg } from "../../../locales/translate.ts";
import { parseRuleBlocks, type RuleRecord } from "./ruleBlocksData";

export const getBanRulesRequest = (projectId: number, page: number, perPage: number) => ({
	method: "rules/config/list", expectedProjectId: projectId, headers: { ignoreBusy: "true" }, data: { page, perPage },
});

export const getBanRuleRequest = (projectId: number, id = -1) => ({
	method: "rules/config/get", expectedProjectId: projectId, headers: { ignoreBusy: "true" }, data: { id },
});

const isRecord = (value: unknown): value is RuleRecord => !!value && typeof value === "object" && !Array.isArray(value);
export const parseBanRules = (payload: unknown) => {
	const parsed = parseRuleBlocks(payload);
	if (parsed) return parsed;
	let body = payload;
	for (let depth = 0; depth < 3 && body && typeof body === "object" && !Array.isArray(body) && "data" in body; depth++) body = (body as RuleRecord).data;
	if (!isRecord(body)) return null;
	const container = body;
	const indexed = [container.items, container.rows, container.list, container.data].find(isRecord);
	const candidate = indexed ?? container;
	const keys = Object.keys(candidate);
	if (!keys.every(key => /^\d+$/.test(key)) || !keys.length && !indexed) return null;
	return parseRuleBlocks({ items: Object.values(candidate), pagination: container.pagination });
};

export const BAN_RULE_COLUMNS = ["name", "enabled", "action", "scope", "updated_at"] as const;

export const banRuleId = (row: RuleRecord): number | null => {
	const value = row.id;
	return (typeof value === "number" || typeof value === "string" && /^\d+$/.test(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : null;
};

// HTTP adds its own data wrapper around the API envelope. Do not pass error: null to FormParser.
export const banRuleFormResponse = (response: IAPIResponse): IAPIResponse => {
	if (response.error) return response;
	let body = response.data;
	if (body && typeof body === "object" && "error" in body) {
		if (body.error) return { error: body.error };
		body = body.data;
	}
	if (body && typeof body === "object" && "data" in body && !("id" in body)) body = body.data;
	if (!body || typeof body !== "object" || Array.isArray(body)) throw new Error(msg("invalidRuleForm"));
	return { data: body };
};
